import React from 'react'
import AppBackBtn from '../../components/ui/AppBackBtn'
import AppWrapper from '../../components/ui/AppWrapper/AppWrapper'
import styles from './GuaranteeView.module.css'

const GuaranteeView: React.FC = () => {
  return (
    <>
      <AppBackBtn to="/home" />
      <AppWrapper className="bg-appLightGray h-[80%] gap-y-2">
        <p className="font-semibold text-black text-base">Уважаемый клиент!</p>
        <p className="text-[14px]">
          Вы можете оплатить свой заказ онлайн с помощью банковской карты через платежный сервис
          компании Uniteller. После подтверждения заказа Вы будете перенаправлены на защищенную
          платежную страницу Uniteller, где необходимо будет ввести данные для оплаты заказа. После
          успешной оплаты на указанную в форме оплаты электронную почту будет направлен электронный
          чек с информацией о заказе и данными по произведенной оплате.
        </p>
        <p className="font-semibold text-black text-base mt-2">Гарантии безопасности</p>
        <p className="text-[14px]">
          Безопасность процессинга Uniteller подтверждена сертификатом стандарта безопасности данных
          индустрии платежных карт PCI DSS. Надежность сервиса обеспечивается интеллектуальной
          системой мониторинга мошеннических операций, а также применением 3D Secure - современной
          технологией безопасности интернет-платежей. Данные Вашей карты вводятся на специальной
          защищенной платежной странице. Передача информации в процессинговую компанию Uniteller
          происходит с применением технологии шифрования TLS. Дальнейшая передача информации
          осуществляется по закрытым банковским каналам, имеющим наивысший уровень надежности.
        </p>
        <div className={styles.attention}>
          <div>
            <i className="fas fa-info-circle"></i>
          </div>
          <div>Uniteller не передает данные Вашей карты магазину и иным третьим лицам!</div>
        </div>
        <p className="text-[14px] mt-2">
          Если Ваша карта поддерживает технологию 3D Secure, для осуществления платежа, Вам
          необходимо будет пройти дополнительную проверку пользователя в банке-эмитенте (банк,
          который выпустил Вашу карту). Для этого Вы будете направлены на страницу банка, выдавшего
          карту. Вид проверки зависит от банка. Как правило, это дополнительный пароль, который
          отправляется в SMS, карта переменных кодов, либо другие способы.
        </p>
      </AppWrapper>
    </>
  )
}

export default GuaranteeView
